import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from '@common/hooks';
import Auth from 'works/legacy/lib/auth';
import { useCurrentEntity } from '@identity/hooks';

export function OrganizationOnly({ children }) {
  const currentEntity = useCurrentEntity();

  // FIXME: talk to spenser about this conditional call issues
  if (Auth.signedIn() && !Auth.organizationMember()) return null;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate();

  const requiresTerms = currentEntity.requiresAcceptTermsConditions;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    // Redirect to Terms and Conditions if Organization hasn't accepted
    if (requiresTerms) {
      navigate('/works/terms-and-conditions');
    }

    // @TODO: verify if history is really missed as a dependency here, since adding it might cause side effects.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requiresTerms]);

  return <>{children}</>;
}

OrganizationOnly.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
